import { ReactElement } from 'react';

type HeaderTabsProps = {
  label: string;
  link: string;
  icon: ReactElement;
};

export const HeaderTabs: HeaderTabsProps[] = [
  {
    label: 'Dashboard',
    link: '/dashboard',
    icon: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9167 15.75V9.74998C11.9167 9.55106 11.8376 9.3603 11.697 9.21965C11.5563 9.07899 11.3656 8.99998 11.1667 8.99998H8.16666C7.96774 8.99998 7.77698 9.07899 7.63633 9.21965C7.49567 9.3603 7.41666 9.55106 7.41666 9.74998V15.75M2.91666 7.49998C2.9166 7.28178 2.96416 7.06619 3.056 6.86826C3.14784 6.67033 3.28175 6.49482 3.44841 6.35398L8.69841 1.85473C8.96915 1.62591 9.31217 1.50037 9.66666 1.50037C10.0211 1.50037 10.3642 1.62591 10.6349 1.85473L15.8849 6.35398C16.0516 6.49482 16.1855 6.67033 16.2773 6.86826C16.3692 7.06619 16.4167 7.28178 16.4167 7.49998V14.25C16.4167 14.6478 16.2586 15.0293 15.9773 15.3106C15.696 15.5919 15.3145 15.75 14.9167 15.75H4.41666C4.01883 15.75 3.6373 15.5919 3.356 15.3106C3.07469 15.0293 2.91666 14.6478 2.91666 14.25V7.49998Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: 'Experiences',
    link: '/experiences',
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.74999 3.75V5.25M9.74999 12.75V14.25M9.74999 8.25V9.75M1.49999 6.75C2.09673 6.75 2.66903 6.98705 3.09098 7.40901C3.51294 7.83097 3.74999 8.40326 3.74999 9C3.74999 9.59674 3.51294 10.169 3.09098 10.591C2.66903 11.0129 2.09673 11.25 1.49999 11.25V12.75C1.49999 13.1478 1.65803 13.5294 1.93933 13.8107C2.22064 14.092 2.60217 14.25 2.99999 14.25H15C15.3978 14.25 15.7793 14.092 16.0607 13.8107C16.342 13.5294 16.5 13.1478 16.5 12.75V11.25C15.9033 11.25 15.331 11.0129 14.909 10.591C14.487 10.169 14.25 9.59674 14.25 9C14.25 8.40326 14.487 7.83097 14.909 7.40901C15.331 6.98705 15.9033 6.75 16.5 6.75V5.25C16.5 4.85218 16.342 4.47064 16.0607 4.18934C15.7793 3.90804 15.3978 3.75 15 3.75H2.99999C2.60217 3.75 2.22064 3.90804 1.93933 4.18934C1.65803 4.47064 1.49999 4.85218 1.49999 5.25V6.75Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: 'Users',
    link: '/users',
    icon: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3333 15.75V14.25C12.3333 13.4544 12.0172 12.6913 11.4546 12.1287C10.892 11.5661 10.129 11.25 9.33331 11.25H4.83331C4.03766 11.25 3.2746 11.5661 2.71199 12.1287C2.14938 12.6913 1.83331 13.4544 1.83331 14.25V15.75M12.3333 2.346C12.9766 2.51278 13.5464 2.88845 13.9531 3.41405C14.3598 3.93965 14.5805 4.58542 14.5805 5.25C14.5805 5.91458 14.3598 6.56035 13.9531 7.08595C13.5464 7.61155 12.9766 7.98722 12.3333 8.154M16.8333 15.75V14.25C16.8328 13.5853 16.6116 12.9396 16.2043 12.4142C15.7971 11.8889 15.2269 11.5137 14.5833 11.3475M10.0833 5.25C10.0833 6.90685 8.74017 8.25 7.08331 8.25C5.42646 8.25 4.08331 6.90685 4.08331 5.25C4.08331 3.59315 5.42646 2.25 7.08331 2.25C8.74017 2.25 10.0833 3.59315 10.0833 5.25Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: 'Credits',
    link: '/credits',
    icon: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.7342 7.7775C14.4432 8.04182 15.0741 8.48065 15.5685 9.0534C16.0629 9.62615 16.405 10.3143 16.563 11.0543C16.721 11.7943 16.6899 12.5621 16.4725 13.2869C16.2551 14.0116 15.8584 14.6699 15.3193 15.2007C14.7801 15.7316 14.1157 16.1179 13.3877 16.3239C12.6596 16.53 11.8914 16.5491 11.1539 16.3796C10.4165 16.2101 9.73377 15.8573 9.16881 15.354C8.60384 14.8507 8.17491 14.213 7.92169 13.5M5.41669 4.5H6.16669V7.5M12.6992 10.41L13.2242 10.9425L11.1092 13.0575M10.6667 6C10.6667 8.48528 8.65197 10.5 6.16669 10.5C3.68141 10.5 1.66669 8.48528 1.66669 6C1.66669 3.51472 3.68141 1.5 6.16669 1.5C8.65197 1.5 10.6667 3.51472 10.6667 6Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: 'Settings',
    link: '/settings',
    icon: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.49832 1.5H9.16831C8.77049 1.5 8.38896 1.65804 8.10765 1.93934C7.82635 2.22064 7.66831 2.60218 7.66831 3V3.135C7.66804 3.39804 7.59861 3.65639 7.46697 3.88413C7.33533 4.11186 7.14612 4.30098 6.91831 4.4325L6.59582 4.62C6.36779 4.75165 6.10912 4.82096 5.84581 4.82096C5.58251 4.82096 5.32384 4.75165 5.09581 4.62L4.98331 4.56C4.63911 4.36145 4.23019 4.30758 3.84632 4.41023C3.46244 4.51288 3.13498 4.76365 2.93581 5.1075L2.77081 5.3925C2.57226 5.7367 2.5184 6.14562 2.62105 6.5295C2.72369 6.91338 2.97447 7.24084 3.31831 7.44L3.43081 7.515C3.65752 7.64588 3.84603 7.83382 3.9776 8.06012C4.10918 8.28643 4.17923 8.54323 4.18081 8.805V9.1875C4.18186 9.45182 4.11305 9.71171 3.98135 9.94088C3.84964 10.17 3.65972 10.3603 3.43081 10.4925L3.31831 10.56C2.97447 10.7592 2.72369 11.0866 2.62105 11.4705C2.5184 11.8544 2.57226 12.2633 2.77081 12.6075L2.93581 12.8925C3.13498 13.2363 3.46244 13.4871 3.84632 13.5898C4.23019 13.6924 4.63911 13.6386 4.98331 13.44L5.09581 13.38C5.32384 13.2483 5.58251 13.179 5.84581 13.179C6.10912 13.179 6.36779 13.2483 6.59582 13.38L6.91831 13.5675C7.14612 13.699 7.33533 13.8881 7.46697 14.1159C7.59861 14.3436 7.66804 14.602 7.66831 14.865V15C7.66831 15.3978 7.82635 15.7794 8.10765 16.0607C8.38896 16.342 8.77049 16.5 9.16831 16.5H9.49832C9.89614 16.5 10.2777 16.342 10.559 16.0607C10.8403 15.7794 10.9983 15.3978 10.9983 15V14.865C10.9986 14.602 11.068 14.3436 11.1997 14.1159C11.3313 13.8881 11.5205 13.699 11.7483 13.5675L12.0708 13.38C12.2988 13.2483 12.5575 13.179 12.8208 13.179C13.0841 13.179 13.3428 13.2483 13.5708 13.38L13.6833 13.44C14.0275 13.6386 14.4364 13.6924 14.8203 13.5898C15.2042 13.4871 15.5317 13.2363 15.7308 12.8925L15.8958 12.6C16.0944 12.2558 16.1482 11.8469 16.0456 11.463C15.9429 11.0791 15.6922 10.7517 15.3483 10.5525L15.2358 10.4925C15.0069 10.3603 14.817 10.17 14.6853 9.94088C14.5536 9.71171 14.4848 9.45182 14.4858 9.1875V8.8125C14.4848 8.54818 14.5536 8.28829 14.6853 8.05912C14.817 7.82995 15.0069 7.63966 15.2358 7.5075L15.3483 7.44C15.6922 7.24084 15.9429 6.91338 16.0456 6.5295C16.1482 6.14562 16.0944 5.7367 15.8958 5.3925L15.7308 5.1075C15.5317 4.76365 15.2042 4.51288 14.8203 4.41023C14.4364 4.30758 14.0275 4.36145 13.6833 4.56L13.5708 4.62C13.3428 4.75165 13.0841 4.82096 12.8208 4.82096C12.5575 4.82096 12.2988 4.75165 12.0708 4.62L11.7483 4.4325C11.5205 4.30098 11.3313 4.11186 11.1997 3.88413C11.068 3.65639 10.9986 3.39804 10.9983 3.135V3C10.9983 2.60218 10.8403 2.22064 10.559 1.93934C10.2777 1.65804 9.89614 1.5 9.49832 1.5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33331 11.25C10.576 11.25 11.5833 10.2426 11.5833 9C11.5833 7.75736 10.576 6.75 9.33331 6.75C8.09067 6.75 7.08331 7.75736 7.08331 9C7.08331 10.2426 8.09067 11.25 9.33331 11.25Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];
